export const MONITOR_OBJECT_TYPE = {
    GUTTER: 1, // 天沟
    ROOF_SLAP: 2, // 屋面板
    WIND_LOCATION: 3, // 风位
}